
import { v4 as uuidv4 } from "uuid";

import Profile1 from "assets/img/team/profile-picture-1.jpg"
import Profile2 from "assets/img/team/profile-picture-2.jpg"
import Profile3 from "assets/img/team/profile-picture-3.jpg"
import Profile4 from "assets/img/team/profile-picture-4.jpg"
import Profile5 from "assets/img/team/profile-picture-5.jpg"
import Profile6 from "assets/img/team/profile-picture-6.jpg"
import Profile7 from "assets/img/team/profile-picture-7.jpg"

export default [
    {
        "id": uuidv4(),
        "image": Profile1,
        "name": "Chris Wood",
        "jobTitle": "Graphic Designer",
        "salary": 1834,
    },
    {
        "id": uuidv4(),
        "image": Profile3,
        "name": "Bonnie Green",
        "jobTitle": "Web Developer",
        "salary": 1355,
    },
    {
        "id": uuidv4(),
        "image": Profile2,
        "name": "Jose Leos",
        "jobTitle": "React Developer",
        "salary": 1297,
    },
    {
        "id": uuidv4(),
        "image": Profile4,
        "name": "Neil Sims",
        "jobTitle": "Python Developer",
        "salary": 875,
    },
    {
        "id": uuidv4(),
        "image": Profile5,
        "name": "Rebbeca Sas",
        "jobTitle": "UI/UX, Art Director",
        "salary": 872,
    },
    {
        "id": uuidv4(),
        "image": Profile6,
        "name": "Jacklyn Brown",
        "jobTitle": "UI/UX, Art Director",
        "salary": 650,
    },
    {
        "id": uuidv4(),
        "image": Profile7,
        "name": "Melinda Norrow",
        "jobTitle": "PHP Developer",
        "salary": 389,
    },
]